import {requirePermission} from '@/modules/auth/permissions'
import {createFileRoute} from '@tanstack/react-router'
import {useGetInfiniteProtocols} from '@/modules/protocols/api'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {Box, HStack} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'
import {ProtocolsTable} from '@/modules/protocols/components'
import {ProtocolsFilters} from '@/modules/protocols/components/protocols-filters'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import * as z from 'zod'

const SearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      substances: z.array(z.uuidv7()).optional(),
      diagnosis: z.array(z.uuidv7()).optional(),
    })
    .optional(),
})

const LIMIT = 50

export const Route = createFileRoute('/configuration/protocols/')({
  beforeLoad: requirePermission('protocols.view'),
  component: RouteComponent,
  validateSearch: SearchSchema,
})

function RouteComponent() {
  const {t} = useTranslate('common')
  const search = Route.useSearch()
  const canManageProtocols = useCan('protocols.manage')

  const infinite = useGetInfiniteProtocols({
    limit: LIMIT,
    filters: {
      search: search.filters?.search,
      substances: search.filters?.substances,
      diagnosis: search.filters?.diagnosis,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        {canManageProtocols ? (
          <LinkButton to="/configuration/protocols/new" marginY="1rem" colorPalette="cyan" size="sm">
            <LuPlus />
            {t('add_new')}
          </LinkButton>
        ) : (
          <Box />
        )}

        <ProtocolsFilters />
      </HStack>
      <ResourcesIndexPageTable>
        <ProtocolsTable virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}} table={{}} />
      </ResourcesIndexPageTable>
    </>
  )
}
